module.exports = __webpack_public_path__ + "static/media/folja.42a553fd.mp3";